import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getTimeFromUTCToTimezone } from '../../../shared/utils/getTimeFromUTCToTimezone';
import { formateNumber } from 'shared/helpers';
import { listForReplace } from './utils';

dayjs.extend(customParseFormat);
export class ReportsApiConverter {
  convertStatisticProvider = (data /* , isOutdated */) => {
    let arrProviders = [];
    arrProviders = Object.keys(data.providers || {}).map(el => ({
      providerKey: el,
      provider: listForReplace?.[el] ?? el,
      betCount: formateNumber(data.providers[el].bet_count),
      betAmount: formateNumber(data.providers[el].bet_amount),
      winAmount: formateNumber(data.providers[el].win_amount),
      incomeAmount: formateNumber(data.providers[el].income_amount),
      rtp: formateNumber(data.providers[el]?.rtp ?? 0),
      activeUsers: data.providers[el]?.active_users == null
        ? undefined
        : formateNumber(data.providers[el].active_users),
    }));

    const detail = {
      betCount: formateNumber(data.detail.total_bet_count),
      betAmount: formateNumber(data.detail.total_bet),
      winAmount: formateNumber(data.detail.total_won),
      incomeAmount: formateNumber(data.detail.total_income),
      commissionBalance: formateNumber(data.detail?.commission_balance ?? 0),
      lastCalculateTime: data.detail?.last_calculate_time
        ? dayjs(data.detail?.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
        : '',
      margin: formateNumber(data.detail.margin),
      activeUsers: data.detail?.active_players == null ? undefined : formateNumber(data.detail.active_players),
      rtp: formateNumber(data.detail?.rtp ?? 0),
      /* isOutdated: isOutdated ?? false, */
    };

    return {
      providers: arrProviders,
      detail,
    };
  };

  convertTimeseries = data => {
    const convertSeries = series =>
      (series || []).map(item => {
        const [date = '', value = 0] = Object.entries(item || {})[0] || [];
        return { date, value: Number(value) || 0 };
      });

    return {
      current: convertSeries(data?.current),
      previous: convertSeries(data?.previous),
    };
  };

  convertProviderRanks = data => ({
    topByNetwin: (data?.top_10_by_netwin || []).map(item => ({
      number: item.number,
      username: item.username,
      netwin: formateNumber(item.netwin),
    })),
    biggestWins: (data?.top_biggest_win || []).map(item => ({
      number: item.number,
      game: item.game,
      win: formateNumber(item.win),
      date: item.date ? dayjs(item.date).format('DD.MM.YYYY') : '',
    })),
  });

  convertStatisticFilter = item => ({
    id: item.id,
    name: item.name,
    description: item.description,
    params: item.params || {},
    createdAt: item.created_at ? dayjs(item.created_at).format('DD.MM.YYYY') : '',
  });

  convertStatisticFilters = data => (data || []).map(this.convertStatisticFilter);

  convertPaymentHistory = data => {
    let arrTransfers = [];
    arrTransfers =
      data?.transfers?.map(el => ({
        id: el?.id,
        operation: el?.operation,
        amount: formateNumber(el?.amount),
        fromUser: el?.from_user,
        toUser: el?.to_user,
        initiatorUser: el?.initiator_user,
        realToUser: el?.real_to_user,
        createdAt: getTimeFromUTCToTimezone(dayjs(el?.created_at, 'YYYY-MM-DDTHH:mm:ss'))?.format('DD/MM/YY HH:mm A'),
        balanceFrom: formateNumber(el?.balance_changes.balance_from),
        balanceTo: formateNumber(el?.balance_changes.balance_to),
      })) || [];

    return {
      transfers: arrTransfers,
      details: {
        totalCount: data?.details?.total_count,
        totalDeposit: formateNumber(data?.details?.total_deposit || data?.totals?.total_deposit || 0),
        totalWithdraw: formateNumber(data?.details?.total_withdraw || data?.totals?.total_withdraw || 0),
        lastCalculateTime: data.details?.last_calculate_time
          ? dayjs(data.details.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
          : '',
        balance: formateNumber(
          data?.details?.total_deposit && data?.details?.total_withdraw
            ? data.details.total_deposit - data.details.total_withdraw
            : data?.totals?.total_withdraw && data?.totals?.total_deposit
            ? data.totals.total_deposit - data.totals.total_withdraw
            : 0,
        ),
        deltaBalance: formateNumber(data?.details?.delta_balance || data?.totals?.delta_balance || 0),
      },
    };
  };

  convertPaymentHistoryTotals = data => {
    return {
      totalDeposit: formateNumber(data?.totals?.total_deposit || 0),
      totalWithdraw: formateNumber(data?.totals?.total_withdraw || 0),
      lastCalculateTime: data.details?.last_calculate_time
        ? dayjs(data.details?.last_calculate_time).add(-3, 'hour').format('DD.MM.YYYY HH:mm')
        : '',
      balance: formateNumber(
        data?.totals?.total_withdraw && data?.totals?.total_deposit
          ? Number(data.totals.total_deposit) - Number(data.totals.total_withdraw)
          : 0,
      ),
      deltaBalance: formateNumber(data?.details?.delta_balance || data?.totals?.delta_balance || 0),
    };
  };

  convertStatisticPlayer = data => {
    let arrStatistics = [];
    arrStatistics = Object.keys(data.user_statistic).map(el => ({
      id: el,
      name: data.user_statistic[el].email,
      amountIn: formateNumber(data.user_statistic[el].amount_in),
      amountOut: formateNumber(data.user_statistic[el].amount_out),
      total: formateNumber(data.user_statistic[el].total),
    }));

    return {
      userStatistic: arrStatistics,
      details: {
        totalCount: /* formateNumber */ data.details.total_count,
      },
    };
  };

  convertSlotsHistory = data => {
    const { detail } = data;

    let arrData = [];
    arrData = data.data.map(el => ({
      id: el.id,
      date: getTimeFromUTCToTimezone(dayjs(el.date, 'YYYY-MM-DDTHH:mm:ss'))?.format('DD/MM/YY HH:mm A'),
      player: el.username,
      provider: el.provider === 'GR8' ? 'ULTIM8' : el.provider,
      amount: formateNumber(el.amount),
      prevBalance: formateNumber(el.balance_before),
      afterBalance: formateNumber(el.balance_after),
      status: el.status,
      userId: el.user_id,
      // gameType: el.gameType,
    }));

    return {
      data: arrData,
      totalCount: /* formateNumber */ data.totalCount,
      details: {
        totalBetCount: detail.total_bet_count,
        totalBet: detail.total_bet,
        totalWon: detail.total_won,
        totalIncome: detail.total_income,
      },
    };
  };

  convertBetsHistory = data => {
    let arrData = [];
    arrData = data.data.map(el => ({
      couponId: el.note,
      date: getTimeFromUTCToTimezone(el.date)?.format('DD/MM/YY'),
      user: el.username,
      type: el.status,
      amount: formateNumber(el.amount),
      balanceBefore: formateNumber(el.balance_before),
      balanceAfter: formateNumber(el.balance_after),
      // userId: el.user_id,
      // isExpress: el.is_express,
      // currency: el.currency,
      // bets: el.bets,
      // totalCoeff: el.total_coeff,
      // winAmount: el.win_amount,
    }));

    return {
      data: arrData,
      count: /* formateNumber */ data.totalCount,
    };
  };

  convertFinanceHistory = data => {
    let arrTransfers = [];
    arrTransfers = data.transfers.map(el => ({
      id: el?.id,
      operation: el?.operation === 0 ? 'deposit' : 'withdrawal',
      // fromUserId: el?.from_user_id,
      // toUserId: el?.to_user_id,
      fromUser: el?.from_user,
      toUser: el?.to_user,
      currency: el?.currency,
      createdAt: getTimeFromUTCToTimezone(el?.created_at)?.format('DD/MM/YY'),
      balanceBeforeFromUser: formateNumber(el?.additional_data.balance_before_from_user),
      balanceBeforeToUser: formateNumber(el?.additional_data.balance_before_to_user),
      balanceAfterFromUser: formateNumber(el?.additional_data.balance_after_from_user),
      balanceAfterToUser: formateNumber(el?.additional_data.balance_after_to_user),
    }));

    return {
      transfers: arrTransfers,
      details: {
        totalCount: /* formateNumber */ data.details.total_count,
      },
    };
  };

  convertBetInfo = data => {
    return {
      provider: data.provider,
      date: dayjs(data.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
      gameName: data.game_name,
      balanceBefore: data.balance_before,
      balanceAfter: data.balance_after,
      userId: data.user_id,
      username: data.username,
      operation: data.operation,
      amount: data.amount,
      refId: data.ref_id,
    };
  };

  convertRequestHistory = data => {
    return {
      count: data.count,
      data:
        data?.items?.map(el => ({
          createdAt: getTimeFromUTCToTimezone(dayjs(el?.created_at, 'YYYY-MM-DDTHH:mm'))?.format('DD/MM/YY HH:mm'),
          id: el?.id,
          username: el?.username,
          operation: el?.type,
          bank: {
            id: el?.bank?.id,
            titular: el?.bank?.titular,
            details: el?.bank?.details,
            bank: el?.bank?.bank,
          },
          phoneNumber: el?.phone_number,
          amount: formateNumber(el?.amount),
          comment: el?.comment,
          bankHolder: el?.name,
          status: el?.status,
          type: el?.type,
          promoCodePercent: el?.promo_code_percent,
        })) || [],
    };
  };
}
